<template>
  <ul class="product-usp">
    <li
      v-for="(usp, index) in usps"
      :key="`product-usp-${index}`"
      class="product-usp__container"
    >
      <div class="product-usp__image-container">
        <responsive-image
          class="product-usp__image"
          :image="usp.productUspImage"
          ratio="1:1"
          min-max="28-84"
          :force-update="true"
          :lazyload="false"
          sizes="28px"
        />
      </div>

      <p
        class="product-usp__title text-heading-l"
        v-text="usp.productUspTitle"
      />
    </li>
  </ul>
</template>

<script>

/**
 * Vue: Product usp (product-usp)
 * -----------------------------------------------------------------------------
 * Product USP.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ProductUsp',

  components: {
    ResponsiveImage,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    variantUspData: {
      type: [Object, Boolean],
      default: false,
    },
  },

  computed: {

    /**
     * Product USP
     * @returns {Array}
     */
    usps() {
      const metafieldUspsArray = this.variantUspData?.[this.variant.id]

      if (!metafieldUspsArray) {
        return []
      }

      return metafieldUspsArray.map((tag) => {
        return window.cnvs.productUsp.find((data) => {
          return tag === data.productUspTag
        })
      }).filter(Boolean)
    },
  },
}
</script>

<style lang="scss">
@import './product-usp';
</style>
